import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const PlayIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path d='M8 5.14001V19.14L19 12.14L8 5.14001Z' />
    </svg>
));

